import React from "react";
import { Helmet } from "react-helmet-async";

const Menu = () => {

  
  return (
    <>
    <Helmet>
        <title>Natural & Healthy Cake Menu Chennai – Eggless & Whole Wheat</title>
        <meta
          name="description"
          content="Explore whole wheat, millet, jaggery cakes & healthy desserts. 100% natural, no preservatives, eggless bakery treats in Chennai."
        />
        <link rel="canonical" href="https://wheatbakes.com/menu" />
      </Helmet>
      
      <div>
        

        <div className="py-5">
          <div class="container">
            <div className="p-3" data-aos="fade-up">
              <p className="text-align-center brown-text-color text-bold-600">
                Menu
              </p>
              <h1 className="text-align-center text-bold-600">
                Naturally baked. Personally delivered. Taste the difference.
              </h1>
            </div>
            <div class="row my-4">
              <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-right">
                <img className="img-fluid" src="images/menu-1.jpg" alt="menu-1" />
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-left">
                <img className="img-fluid" src="images/menu-2.jpg" alt="menu-2" />
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;
